// Severity of a system status message. Values mirror the backend V4
// `MessageType` enum (DHI.WaterData.IAM.Web.Contracts.V4.MessageType) exactly,
// so they can be sent/received without translation.
export enum Severity {
  Critical = 10,
  Warning = 20,
  Informational = 30
}

// Lifecycle status is always DERIVED from the schedule, never stored.
export type DerivedStatus = 'Pending' | 'Active' | 'Expired'

// A global system status message as returned by
// GET /api/admin/feature/message (featureId is always null for these).
export default interface ISystemStatusMessage {
  id: number
  featureId: string | null
  type: Severity
  title: string
  body: string
  startDate: string // ISO 8601, UTC
  expiringDate: string // ISO 8601, UTC
}

// Shape sent to POST/PATCH. featureId is derived server-side (null for global).
export interface ISystemStatusMessageInput {
  type: Severity
  title: string
  body: string
  startDate: string
  expiringDate: string
}
